import { render, staticRenderFns } from "./SamclickCol.vue?vue&type=template&id=5de5456e&functional=true&"
import script from "./SamclickCol.vue?vue&type=script&lang=ts&"
export * from "./SamclickCol.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports